import React, { Component } from "react";
import ScrollableAnchor from 'react-scrollable-anchor'
import 'whatwg-fetch'

import "./Item.scss"
import dataJSON from "../../api/Items.json"
import throttle from 'lodash.throttle'

class Item extends Component {
  constructor() {
    super();
    this.state = {
      isLoaderActive: true,
      itemHTML: null,
      itemHTML_alt: null,
      isReadMoreActive: false,
      isInRange: false,
    }
    this.readMore = this.readMore.bind(this);
    this.readLess = this.readLess.bind(this);
    this.fetchItem = this.fetchItem.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    this.fetchItem("few");
    window.addEventListener('scroll', throttle(this.handleScroll, 500));

  }
  handleScroll() {
    const scrollTop = window.scrollY,
      height = this.node.clientHeight / 1.4,
      top = this.node.offsetTop,
      isInRange = scrollTop >= top && scrollTop <= (top + height);
    this.setState({
      isInRange: isInRange
    });
  }
  replaceHTML(str) {
    str = str.replace(new RegExp("<p>", "g"), "")
      .replace(new RegExp("</p>", "g"), "");
    return str;
  }
  getRect(obj) {
    var rect = {
      top: obj.top + document.body.scrollTop,
      left: obj.left + document.body.scrollLeft
    }
    /*

      position: Math.round(item * (obj ? obj.offsetWidth : this.state.itemWidth) / 2)
      */
    return rect;
  }
  readMore() {
    if (this.state.isReadMoreActive) {
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'nespresso',
        'Action': 'Close_Article_Clicked',
        'Label': dataJSON[this.props.item].text
      });
      window.setTimeout(() => {
        window.scrollTo(0, this.node.offsetTop - 150);
      }, 500);
      this.readLess();
    } else {
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'nespresso',
        'Action': 'Read_More_Clicked',
        'Label': dataJSON[this.props.item].text
      });
      this.fetchItem("all");
    }
  }
  readLess() {
    this.setState({
      isReadMoreActive: false
    })
  }
  fetchItem(opt) {
    fetch(`./static/api/${dataJSON[this.props.item].file}`)
      .then(data => data.text())
      .then(data => {
        this.setState({
          isLoaderActive: false
        })
        if (opt == "few") {
          this.setState({
            itemHTML_alt: this.replaceHTML(data).substr(0, dataJSON[this.props.item].maxLength)
          })
        } else {
          this.setState({
            itemHTML: data,
            isReadMoreActive: true
          })
        }
      })
      .catch(err => console.error(this.props.url, err.toString()));
  }
  render() {
    const image = {
      backgroundImage: `url(./static/images/desktop/items/${dataJSON[this.props.item].image})`
    }
    return (
      <section className={`section section-item item${this.props.item}`} ref={node => { this.node = node }}>
        <div className="padding">
          <div className="container">
            <div className="flowers">
              <div className={`item${this.props.item}`}></div>
            </div>
            <ScrollableAnchor id={`item${this.props.item}`}>
              <div className="headline">
                <h3 dangerouslySetInnerHTML={{ __html: dataJSON[this.props.item].text }}></h3>
              </div>
            </ScrollableAnchor>
            <div className={`fullteaser${this.state.isReadMoreActive ? " active" : ""}`}>
              <div className="separator"></div>
              <div className="text" dangerouslySetInnerHTML={{ __html: `${dataJSON[this.props.item].teaser}` }}></div>
            </div>
            <div className={`article-item${this.state.isReadMoreActive ? " active" : ""}`}>
              <div className="image" style={image}>
                <div className="credit">{dataJSON[this.props.item].credit}</div>
              </div>
              <div className="separator"></div>
              <div className={`alternate${this.state.isReadMoreActive ? " active" : ""}`}>
                <div className="text teaser" dangerouslySetInnerHTML={{ __html: `${dataJSON[this.props.item].teaser}` }}></div>
                <div className="text full" dangerouslySetInnerHTML={{ __html: this.state.itemHTML }}></div>
              </div>
              <div className={`button float${dataJSON[this.props.item].readmoreFloat && this.state.isReadMoreActive && this.state.isInRange ? " active" : ""}`} onClick={this.readMore}>
                <div className="button-text">
                  {(this.state.isReadMoreActive ? dataJSON[this.props.item].button.alt_text : dataJSON[this.props.item].button.text)}
                </div>
              </div>
              <div className="button" onClick={this.readMore}>
                <div className="button-text">
                  {(this.state.isReadMoreActive ? dataJSON[this.props.item].button.alt_text : dataJSON[this.props.item].button.text)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/Components/Item/Item.js